import '../../library/print-this/print-this'
import $ from 'jquery';

/**
 * Print download button feature.
 */
class Print {
	_printBtn;
	_printCtn;

	/**
	 * Define the button/s when initializing.
	 *
	 * @param printBtnSelector
	 */
	constructor( printBtnSelector = '.print-btn' ) {
		this.printBtn = $( printBtnSelector );

		if ( this.printBtn.length ) {
			this.bindEvents();
		}
	}

	/**
	 * Bind the on click event.
	 */
	bindEvents() {
		this.printBtn.on( 'click', ( e ) => this.clickDownload( e ) );
	}

	/**
	 * The event handling.
	 *
	 * @param e
	 */
	clickDownload( e ) {
		e.preventDefault();

		// Get the element that will be printed.
		const printCtnSelector = $( e.currentTarget ).attr( 'data-print-ctn-id' );

		// No data attribute for the id of the element that needs to be printed.
		if ( ! printCtnSelector ) {
			return;
		}

		this.printCtn = $( `#${ printCtnSelector }` );

		// No element matching the id provided.
		if ( ! this.printCtn.length ) {
			return;
		}

		this.printElement();
	}

	/**
	 * Print feature. swap this out with any print library.
	 * Based of the print library available here
	 * https://github.com/jasonday/printThis/wiki
	 */
	printElement() {
		if ( this.printCtn.length && typeof this.printCtn.printThis === 'function' ) {
			this.printCtn.printThis(
				{
					debug: false,               // show the iframe for debugging
					importCSS: true,            // import parent page css
					importStyle: true,          // import style tags
					printContainer: true,       // print outer container/$.selector
					loadCSS: "",                // path to additional css file - use an array [] for multiple
					pageTitle: "",              // add title to print page
					removeInline: false,        // remove inline styles from print elements
					removeInlineSelector: "*",  // custom selectors to filter inline styles. removeInline must be true
					printDelay: 700,            // variable print delay, if this is to fast data is missing.
					header: null,               // prefix to html
					footer: null,               // postfix to html
					base: false,                // preserve the BASE tag or accept a string for the URL
					formValues: true,           // preserve input/form values
					canvas: false,              // copy canvas content
					doctypeString: '...',       // enter a different doctype for older markup
					removeScripts: false,       // remove script tags from print content
					copyTagClasses: false,      // copy classes from the html & body tag
					beforePrintEvent: null,     // function for printEvent in iframe
					beforePrint: null,          // function called before iframe is filled
					afterPrint: null            // function called before iframe is removed
				}
			);
		}
	}

	/** ------------------------------------------------------------------------------------------
	 * Setters.
	 * ------------------------------------------------------------------------------------------ */

	set printBtn( value ) {
		this._printBtn = value;
	}

	set printCtn( value ) {
		this._printCtn = value;
	}

	/** ------------------------------------------------------------------------------------------
	 * Getters.
	 * ------------------------------------------------------------------------------------------ */

	get printBtn() {
		return this._printBtn;
	}

	get printCtn() {
		return this._printCtn;
	}
}

// eslint-disable-next-line no-shadow
( function( $ ) {
	'use strict';
	new Print();
// eslint-disable-next-line no-undef
}( jQuery ) );